// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".social-icons[data-v-470d390b]{margin:10px auto}.social-icons>*[data-v-470d390b]{margin-left:10px}", ""]);
// Exports
module.exports = exports;
